import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import TemplateDetailSlider from '../TemplateDetailSlider';
import FunctionalGroup from '../FunctionalGroup';
import Charm from 'components/SeriesDetail/Charm';
import ConditionalImage from 'components/shared/ConditionalImage';

const text = {
  loading: 'Loading...',
};

const TemplateDetail = ({
  addDisclaimer,
  charmsForTemplate,
  closeDetail,
  closeString,
  designPackageForTemplate,
  designPackageHeader,
  detailImages,
  detailString,
  formattedPriceBand,
  formattedTotalPrice,
  functionalGroupCodes,
  functionalGroupHeader,
  mini,
  priceBandId,
  priceBandLabel,
  suggestedLabel,
  suggestedQuant,
  suggestedUnits,
  templateDetailImagesLoading,
  templateOverviewHeader,
  totalPriceLabel,
}) => (
  <div className={styles.templateDetailExpanded}>
    <div className={styles.closeDetailContainer}>
      <button className={styles.closeDetailButton} onClick={closeDetail}>
        {closeString} {detailString}
      </button>
    </div>
    {templateDetailImagesLoading ? (
      <div className={styles.detailImageLoading}>{text.loading}</div>
    ) : (
      <TemplateDetailSlider
        images={detailImages}
        mini
        addDisclaimer={addDisclaimer}
      />
    )}
    <div className={styles.templateDetail}>
      <div className={styles.templateDetailColumn}>
        <span className={styles.detailHeader}>{functionalGroupHeader}</span>
        <ul className={styles.templateDetailSpecs}>
          {functionalGroupCodes.map(code => (
            <FunctionalGroup key={code} functionalCode={code} />
          ))}
        </ul>
      </div>
      <div className={styles.templateDetailColumn}>
        <span className={styles.detailHeader}>{designPackageHeader}</span>
        <ul className={styles.templateDetailSpecs}>
          {designPackageForTemplate.optionKeys.map(optionKey => (
            <li key={optionKey} className={styles.templateDetailSpec}>
              <ConditionalImage
                altText={designPackageForTemplate[optionKey].id}
                className={styles.icon}
                imgUrl={designPackageForTemplate[optionKey].iconImgUrl}
              />
              {designPackageForTemplate[optionKey].description} ($
              {designPackageForTemplate[optionKey].upcharge})
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.templateDetailColumn}>
        <span className={styles.detailHeader}>{templateOverviewHeader}</span>
        <ul className={styles.templateDetailSpecs}>
          <li className={styles.templateDetailSpec}>
            <span className={styles.templateOverViewLabels}>
              {totalPriceLabel}
            </span>
            {formattedTotalPrice}
          </li>
          <li className={styles.templateDetailSpec}>
            <span className={styles.templateOverViewLabels}>
              {priceBandLabel} {priceBandId}{' '}
            </span>
            {formattedPriceBand}
          </li>
          <li className={styles.templateDetailSpec}>
            <span className={styles.templateOverViewLabels}>
              {suggestedLabel}
            </span>
            {suggestedQuant} {suggestedUnits}
          </li>
          <li className={styles.charms}>
            {charmsForTemplate.map(charm => (
              <Charm charm={charm} detail={true} />
            ))}
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default enhance(TemplateDetail);
